import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { FilterModalModule } from '@helios/filter-modal'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbDropdownModule,
  NgbModalModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import { NfFormsModule } from '@northfork/ng-basics'
import { WorkbenchColumnManagerComponent } from '../column-manager/workbench-column-manager.component'
import { AggInfoColumnFilterComponent } from '../../grid/filters/agg-info-column-filter.component'
import { UnmatchModalComponent } from '../unmatch-modal/unmatch-modal.component'
import { WorkbenchGridComponent } from './workbench-grid.component'

@NgModule({
  imports: [
    // Angular Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Third Party Modules
    NgbDropdownModule,
    NgbModalModule,
    NgbTooltipModule,

    // Northfork Modules
    NfFormsModule,
    TableLayoutModule,

    // Helios Modules
    GenericComponentsModule,
    // Also supplies hs-column-type-picker, which the AGGREGATE_INFO grid-header filter hosts so the
    // header and the filter modal present the SAME control.
    FilterModalModule,
  ],
  declarations: [
    WorkbenchGridComponent,
    // Opened imperatively by the grid's Unmatch action when a group spans more than one other
    // source. NgbModalModule (above) is what lets NgbModal.open resolve it.
    UnmatchModalComponent,
    WorkbenchColumnManagerComponent,
    AggInfoColumnFilterComponent,
  ],
  exports: [WorkbenchGridComponent],
})
export class WorkbenchGridModule {}
